
import {
    IMatchHistory, IDonorRecordReview, ICluster, IPosition, IDashContactDue,
    IXmTracking, IRecipient, IRecipientCompliance, IDonorCompliance, IDonor, IReferral, IConfirmDashDonation, IDonorWithRemoteRecipient, IMicrositeRecipientPendApproval,
    IRequestForDonorReview, IWageAndTravelRequest, IVoucherDonor, IMissingVoucherConsent, IPatientIntakeListItem, IMicrositeRecipientCompliance,
    IActionCenterWatrRequestWeek,
    IImmunofreeCandidate,
    ICenterContactPosition,
    IStrongBoxComplianceItem,
    IPassMissingRecipientProfile,
    IPackagingRemittanceComplianceData
} from "@nkr/models/index";

import { ICenterCompliance } from '../../../models/center-performance';

type ListType =
    IMatchHistory
    | IDonorRecordReview
    | ICluster
    | IPosition
    | IDashContactDue
    | IXmTracking
    | IRecipient
    | IRecipientCompliance
    | IDonorCompliance
    | ICenterCompliance
    | IDonor
    | string
    | number
    | IReferral
    | IConfirmDashDonation
    | IRequestForDonorReview
    | IWageAndTravelRequest
    | IVoucherDonor
    | IMissingVoucherConsent
    | IPatientIntakeListItem
    | IMicrositeRecipientCompliance
    | IActionCenterWatrRequestWeek
    | IDonorWithRemoteRecipient
    | IImmunofreeCandidate
    | IMicrositeRecipientPendApproval
    | ICenterContactPosition
    | IPassMissingRecipientProfile
    | IStrongBoxComplianceItem
    | IPackagingRemittanceComplianceData
    ;

export default ListType;